"use client";
import { createSafeContext } from "../../core/utils/create-safe-context/create-safe-context.mjs";
//#region packages/@mantine/core/src/components/Drawer/Drawer.context.ts
const [DrawerProvider, useDrawerContext] = createSafeContext("Drawer component was not found in tree");
//#endregion
export { DrawerProvider, useDrawerContext };

//# sourceMappingURL=Drawer.context.mjs.map